module.exports = __webpack_public_path__ + "static/js/0.387a5ac9.chunk.worker.js"